import {Configuration, DefaultApi, type Middleware} from "~/models";
const doNotTrackErrorsON = [
    '/api/auth/session',
    '/api/auth/token',
]

// silent=true — не чіпати глобальний NuxtLoadingIndicator (верхня смуга).
// Для фонових запитів мапи, де прогрес показуємо локально (напр. збереження позиції літака).
export const useApi = (opts?: {silent?: boolean}) => {
    const {showApiError} = useApiErrors()
    const {markServerReachable, markApiUnreachable} = useConnectionStatus()
    const {start, finish} = useLoadingIndicator()
    const silent = opts?.silent ?? false

    return new DefaultApi(new Configuration({
        basePath: '',
        middleware: [
            {
                pre: (context) => {
                    if (!silent) start()
                },
            } as Middleware,
            {
                post: (context) => {
                    if (!silent) finish()

                    if (isGatewayStatus(context.response.status)) {
                        markApiUnreachable()
                    } else {
                        markServerReachable()
                    }

                    if (context.response.ok) {
                        return
                    }

                    if (!doNotTrackErrorsON.includes(context.url)) {
                        showApiError(context.response.status, context.response)
                    }
                },
            } as Middleware,
            {
                // Запит не отримав відповіді взагалі (нема мережі, сервер не відповідає). Нічого
                // не повертаємо — runtime далі кидає FetchError, як і раніше.
                onError: async (context) => {
                    if (!silent) finish()
                    if (!context.response) markApiUnreachable()
                },
            } as Middleware,
        ]
    }))
}